/**
 * User: nir
 * Date: 06/09/2016
 * Time: 18:11
 */

window.jQuery(function ($) {
        var $allVideos = $("iframe");

        // Figure out and save aspect ratio for each video
        $allVideos.each(function () {
            if ($(this).attr('data-tct-allow-resize') === 'true')
                return;

            $(this)
                .data('aspectRatio', this.height / this.width)

                // and remove the hard coded width/height
                .removeAttr('height')
                .removeAttr('width')
                .hide();

        });

        // When the window is resized
        $(window).on('resize', function () {
            // Resize all videos according to their own aspect ratio
            $allVideos.each(function () {

                var $el = $(this);

                // Get the width of parent element
                // The element that is fluid width
                var newWidth = $el.parent().width();

                $el
                    .width(newWidth)
                    .height(newWidth * $el.data('aspectRatio'))
                    .show();
            });

            // Kick off one resize to fix all videos on page load
        }).trigger('resize');
    }
);